import { useGet } from '../useFetch';

export const useGetFundsAccess = () =>
  useGet('/api/news/announcements/', {
    apiPrefix: 'fund-analysis',
    params: { offset: 0, limit: 1 },
    disableLogout: true,
    response: 'raw',
  });
